<section class="py-4 py-lg-5 px-xl-4 px-2">
  <div class="d-flex justify-content-end">
    <button (click)="agendamentoPorLote()" class="btn btn-sm btn-success">
      <i class="mdi mdi-plus"></i>
      Agendar lote
    </button>
  </div>
  <br>
  <div class="card">
    <div class="card-header bg-white">
      <h3>Laudo</h3>
    </div>

    <div class="row m-2">
      <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
        <label class="text-truncate mw-100" for="solicitante">Solicitante</label>
        <select [formControl]="formVistoria.controls.cliente" name="solicitante" id="solicitante" class="form-control">
          <option value="">Selecione</option>
          <option value="0">AVULSO</option>
          <option *ngFor="let o of listaClientes" [value]="o.id">{{o.nomefantasia}}</option>
        </select>
        <app-msg-erro [control]="formVistoria.controls.cliente"></app-msg-erro>
      </div>
      <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
        <label class="text-truncate mw-100" for="vistoriadora">Vistoriadora</label>
        <select [formControl]="formVistoria.controls.unidadeRealizadora" name="vistoriadora" id="vistoriadora" (change)="pesquisaVistoriador()"
          class="form-control">
          <option value="">Selecione</option>
          <option *ngFor="let o of listaUnidades" [value]="o.id">{{o.nomefantasia}}</option>
        </select>
        <app-msg-erro [control]="formVistoria.controls.unidadeRealizadora"></app-msg-erro>
      </div>
      <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
        <label class="text-truncate mw-100" for="vistoriadora">Vistoria</label>
        <select [formControl]="formVistoria.controls.tipolaudo" name="vistoria" id="vistoria" class="form-control">
          <option value="">Selecione</option>
          <option *ngFor="let o of listaTipoLaudo" [value]="o.id">{{o.nome}}</option>
        </select>
        <app-msg-erro [control]="formVistoria.controls.tipolaudo"></app-msg-erro>
      </div>
      <div class="col-12 col-sm-6 col-xl-3 pb-2 px-3">
        <label class="text-truncate mw-100" for="vistoriadora">Vistoriador</label>
        <select [formControl]="formVistoria.controls.vistoriador" name="vistoriador" id="vistoriador" class="form-control">
          <option value="">Selecione</option>
          <option *ngFor="let o of listaVistoriador" [value]="o.id">{{o.nomeVistoriador}}</option>
        </select>
        <div  *ngIf="errorMessage" class="error-message text-right text-danger f-12">
          {{ errorMessage }}
        </div>
        <app-msg-erro [control]="formVistoria.controls.vistoriador"></app-msg-erro>
      </div>
    </div>
  </div>

  <div class="card my-5">
    <div class="card-header bg-white">
      <h3>Veículo</h3>
    </div>

    <div class="row m-2">

      <div class="col-sm-6 col-lg-3 col-xl-2 p-2">
        <label class="text-truncate mw-100" for="placa">Placa</label>
        <div class="input-group">
          <input [textMask]="mask.placa" [formControl]="formVeiculo.controls.placa" id="placa" type="text"
            class="form-control">
          <button (click)="pesquisaVeiculo('placa')" class="input-group-append border-0 btn btn-info btn-icon">
            <i class="mdi mdi-magnify"></i>
          </button>
        </div>
        <app-msg-erro [control]="formVeiculo.controls.placa"></app-msg-erro>
      </div>
      <div class="col-sm-6 col-lg-3 col-xl-2 p-2">
        <label class="text-truncate mw-100" for="chassi">Chassi</label>
        <div class="input-group">
          <input [formControl]="formVeiculo.controls.chassi" name="chassi" id="chassi" class="form-control">
          <button (click)="pesquisaVeiculo('chassi')" class="input-group-append border-0 btn btn-info btn-icon">
            <i class="mdi mdi-magnify"></i>
          </button>
        </div>
        <app-msg-erro [control]="formVeiculo.controls.chassi"></app-msg-erro>
      </div>
      <div class="col-sm-6 col-lg-3 col-xl-1 p-2">
        <label class="text-truncate mw-100" for="anofab">Ano Fabricação</label>
        <input [formControl]="formVeiculo.controls.anoFab" type="text" id="anofab" class="form-control">
        <app-msg-erro [control]="formVeiculo.controls.anoFab"></app-msg-erro>
      </div>
      <div class="col-sm-6 col-lg-3 p-2 col-xl-1">
        <label class="text-truncate mw-100" for="anomod">Ano Modelo</label>
        <input [formControl]="formVeiculo.controls.anoMod" type="text" id="anomod" class="form-control">
        <app-msg-erro [control]="formVeiculo.controls.anoMod"></app-msg-erro>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-2 p-2">
        <label class="text-truncate mw-100" for="marca">Marca</label>
        <input [formControl]="formVeiculo.controls.marca" type="text" id="marca" class="form-control">
        <app-msg-erro [control]="formVeiculo.controls.marca"></app-msg-erro>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-2 p-2">
        <label class="text-truncate mw-100" for="modelo">Modelo</label>
        <input [formControl]="formVeiculo.controls.modelo" type="text" id="modelo" class="form-control">
        <app-msg-erro [control]="formVeiculo.controls.modelo"></app-msg-erro>
      </div>
      <div class="col-lg-4 col-xl-2 p-2">
        <label class="text-truncate mw-100" for="ufplaca">Uf Placa</label>
        <select [formControl]="formVeiculo.controls.ufPlaca" type="text" id="ufplaca" class="form-control">
          <option value="">Selecione</option>
          <option *ngFor="let o of ufOptions" [value]="o.value">{{o.label}}</option>
        </select>
        <app-msg-erro [control]="formVeiculo.controls.ufPlaca"></app-msg-erro>
      </div>

    </div>
  </div>

  <div class="card my-5">
    <div class="card-header bg-white">
      <h3>Local de realização</h3>
    </div>

    <div class="row m-2">
      <div class="col-sm-6 col-lg-5 col-xl-4 p-2">
        <div class="d-flex">
          <div class="w-100">
            <label class="text-truncate mw-100" for="placa">Cep</label>
            <input [formControl]="formEndereco.controls.cep" [textMask]="mask.cep" id="cep" type="text"
              class="form-control">
            <app-msg-erro [control]="formEndereco.controls.cep"></app-msg-erro>
          </div>
          <div class="text-nowrap pl-3">
            <div>
              Não lembra do seu CEP?
            </div>
            <a href="http://www.buscacep.correios.com.br/sistemas/buscacep/" rel="noopener noreferrer" target="_blank"
              class="btn btn-outline-info fw-500 w-100 mt-1">Clique aqui</a>
          </div>
        </div>

      </div>

      <div class="col-sm-6 col-lg-3 col-xl-3 p-2">
        <label class="text-truncate mw-100" for="bairro">Bairro</label>
        <input [formControl]="formEndereco.controls.bairro" name="bairro" id="bairro" class="form-control">
        <app-msg-erro [control]="formEndereco.controls.bairro"></app-msg-erro>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3 p-2">
        <label class="text-truncate mw-100" for="Logradouro">Logradouro</label>
        <input [formControl]="formEndereco.controls.logradouro" type="text" id="Logradouro" class="form-control">
        <app-msg-erro [control]="formEndereco.controls.logradouro"></app-msg-erro>
      </div>
      <div class="col-sm-6 col-lg-4 p-2 col-xl-2">
        <label class="text-truncate mw-100" for="cidade">Cidade</label>
        <input [formControl]="formEndereco.controls.cidade" placeholder="Cidade por extenso" type="text" id="cidade"
          class="form-control">
        <app-msg-erro [control]="formEndereco.controls.cidade"></app-msg-erro>
      </div>
      <div class="col-sm-6 col-lg-1 col-xl-1 p-2">
        <label class="text-truncate mw-100" for="numero">Nº</label>
        <input [formControl]="formEndereco.controls.numero" type="number" id="numero" class="form-control">
        <app-msg-erro [control]="formEndereco.controls.numero"></app-msg-erro>
      </div>
      <div class="col-sm-6 col-lg-3 col-xl-3 p-2">
        <label class="text-truncate mw-100" for="estado">Estado</label>
        <select [formControl]="formEndereco.controls.uf" type="text" id="estado" class="form-control">
          <option value="">Selecione</option>
          <option *ngFor="let o of ufOptions" [value]="o.value">{{o.label}}</option>
        </select>
        <app-msg-erro [control]="formEndereco.controls.uf"></app-msg-erro>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-4 p-2">
        <label class="text-truncate mw-100" for="complemento">Complemento</label>
        <input [formControl]="formEndereco.controls.complemento" type="text" id="complemento" class="form-control">
        <app-msg-erro [control]="formEndereco.controls.complemento"></app-msg-erro>
      </div>
      <div class="w-100 p-2">
        <label class="text-truncate mw-100" for="obs">Referência/Obs</label>
        <textarea [formControl]="formEndereco.controls.referencia" name="obs" id="obs" rows="3"
          class="form-control"></textarea>
        <app-msg-erro [control]="formEndereco.controls.referencia"></app-msg-erro>
      </div>
    </div>
  </div>

  <div class="card my-5">
    <div class="card-header bg-white">
      <h3>Agendamento</h3>
    </div>

    <!-- <div class="row align-items-end m-2">
      <div class="col-sm-6 col-lg-4 p-2">
        <label class="text-truncate mw-100" for="dataDesejada">Data Desejada</label>
        <input id="dataDesejada" [minDate]="dataInicioAgendamento" (focus)="dataDesejada.open()" name="dataDesejada"
          [formControl]="formAgendamento.controls.dataAgendamento" ngbDatepicker #dataDesejada="ngbDatepicker"
          type="text" class="form-control">
          <app-msg-erro [control]="formAgendamento.controls.dataAgendamento"></app-msg-erro>
      </div>

      <div class="col-sm-6 col-lg-2 p-2">
        <label class="text-truncate mw-100" for="horaDesejada">Horário</label>
        <input [formControl]="formAgendamento.controls.hora" type="text" id="hora" class="form-control" [textMask]="mask.hora">
        <app-msg-erro [control]="formAgendamento.controls.hora"></app-msg-erro>
      </div>
    </div> -->

    <div class="row align-items-end m-2">
      <div class="col-sm-4 col-lg-2 p-2">
        <label class="text-truncate mw-100" for="dataDesejada">Data Desejada</label>
        <input id="dataDesejada" [minDate]="dataInicioAgendamento" (focus)="dataDesejada.open()" (ngModelChange)="dataDesejada.toggle(); dataDesejada.close();$event.stopPropagation()" name="dataDesejada"
          [formControl]="formAgendamento.controls.dataAgendamento" ngbDatepicker #dataDesejada="ngbDatepicker"
          type="text" class="form-control" >
          <app-msg-erro [control]="formAgendamento.controls.dataAgendamento"></app-msg-erro>
      </div>
      <div class="col-sm-4 col-lg-2 p-2">
        <label class="text-truncate mw-100" for="periodo">Período</label>
        <select [formControl]="formAgendamento.controls.periodo" type="text" id="periodo" class="form-control">
          <option value="">Selecione</option>
          <option value="0">Manhã</option>
          <option value="1">Tarde</option>
        </select>
      </div>
    </div>
  </div>

  <!-- integração hg  -->
  <div class="card my-5">
    <div class="card-header bg-white">
      <h3>Habilitar integração HG ?</h3>
    </div>

  <div class="d-flex p-2">
    <p-selectButton class="selectButton" [options]="stateOptions" [(ngModel)]="desejaIntegrar" (onChange)="desejaIntegrarHg()" optionLabel="label" optionValue="desejaIntegrar"></p-selectButton>
  </div>
  <div *ngIf="desejaIntegrar" class="p-2">
    <div class="row">
        <div *ngIf="!isAutenticadoHg" class="card" style="width: 40%;">
          <div class="card-body">
            <form>
              <div class="form-group">
                <label for="email">Nome de Usuário:</label>
                <input #email type="email" class="form-control" id="email" ng-model="email" required>
              </div>
              <div class="form-group">
                <label for="senha">Senha:</label>
                <input #senha type="password" class="form-control" id="senha" ng-model="senha" required>
              </div>
              <button type="submit" (click)="authHg(email.value, senha.value)" class="btn btn-primary">Login</button>
            </form>
          </div>
        </div>
        <div *ngIf="isAutenticadoHg" class="card" style="width: 40%;">
          <div class="card-body">
            <h4>Autenticação concluida</h4>
            <p>{{emailHg}}</p>
            <br>
            <button (click)="deslogar()" class="btn btn-primary">Desconectar</button>
          </div>
        </div>
        <br>
    </div>
  </div>
</div>
  <div class="d-flex justify-content-end flex-column align-items-end">
    <div *ngIf="desejaIntegrar && desabilitaCriar">
      <h4 class="w-100">Realize a autenticação para prosseguir</h4>
    </div>
    <button [disabled]="desabilitaCriar" (click)="salvar()" class="btn btn-lg px-5 btn-success">
      Confirmar
    </button>
  </div>

</section>
